import { Heading, Box, Select, Flex, Text, Grid, GridItem, Button } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import AdminSidePage from "../Components/AdminSidePage";
import ProductAddToCart from "../Components/OrderItem";
import { ProductCard } from "../Components/ProductItemAdmin";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { SkeletonTrack } from "../Components/SkeletonTrack";

const TrackOrder = () => {
    return <AdminSidePage children={<Content />} page="DashBoard" />;
};

const Content = () => {
    let [order, setorder] = useState([]);

    const [searchParams, setSearchParams] = useSearchParams({});
    const sortParam = searchParams.get("sort");
    const [sort, setsort] = useState(sortParam);
    const length = useRef(null);

    const typeParam = searchParams.get("type");
    const [type, settype] = useState(typeParam);

    const qpage = searchParams.get("page");
    const [page, setpage] = useState(qpage || 1);
    const [loading, setloading] = useState(false);

    async function toggleStatus(id, status) {
        let data = await axios.patch(
            `${process.env.REACT_APP_BACKEND_API}/allorder/update/${id}`,
            { status: !status },
            {
                headers: {
                    Authorization: process.env.REACT_APP_TOKEN,
                },
            }
        );

        getOrderData();
    }

    async function deleteItem(id) {
        let data = await axios.delete(`${process.env.REACT_APP_BACKEND_API}/allorder/delete/${id}`, {
            headers: {
                Authorization: process.env.REACT_APP_TOKEN,
            },
        });

        getOrderData();
    }

    async function getOrderData() {
        setloading(true);
        try {
            let data = await axios.get(`${process.env.REACT_APP_BACKEND_API}/allorder`, {
                params: {
                    page: qpage == undefined ? 1 : qpage,
                    type,
                },
                headers: {
                    Authorization: process.env.REACT_APP_TOKEN,
                },
            });
            console.log(data.data, "data data data");
            length.current = data.data.length;
            setloading(false);
            setorder(data.data.data);
        } catch (error) {
            console.log("error in fetching the data");
        }
    }

    function changePage(e) {
        let temp = typeof e != "number" ? Number(e.target.innerText) : e;
        setSearchParams({
            page: temp,
        });
        setpage(temp);
    }

    useEffect(() => {
        let obj = {};
        if (sort) obj.sort = sort;
        if (type) obj.type = type;
        if (page) obj.page = page;
        setSearchParams(obj);
        console.log(obj);
        getOrderData();
    }, [sort, type, page]);

    if (sort) {
        let data;
        if (sort == "asc")
            data = order.sort(function (a, b) {
                return +a.price - +b.price;
            });
        if (sort == "desc")
            data = order.sort(function (a, b) {
                return +b.price - +a.price;
            });
        order = data;
    }
    // if (type) {
    //   let data = order.filter((el) => {
    //     return el.type == type;
    //   });
    //   order = data;
    // }
    return (
        <Box>
            <Box w="100%" bg="white" m="auto">
                <Flex justifyContent={"space-between"}>
                    <Text display={{ base: "none", md: "unset" }} fontSize={"20px"} fontWeight="bold">
                        Track Order
                    </Text>
                    <Flex>
                        <Flex mr="20px">
                            <Select
                                cursor={"pointer"}
                                onChange={(e) => {
                                    settype(e.target.value);
                                }}
                                placeholder="Products Category"
                            >
                                <option value="men">Mens</option>
                                <option value="women">Womens</option>
                            </Select>
                        </Flex>

                        <Flex alignItems={"center"}>
                            <Select
                                cursor={"pointer"}
                                onChange={(e) => {
                                    setsort(e.target.value);
                                }}
                                placeholder="Sort Items"
                            >
                                <option value="asc">Low To High</option>
                                <option value="desc">High To Low</option>
                            </Select>
                        </Flex>
                    </Flex>
                </Flex>
            </Box>
            <Box>
                <Grid
                    gap="4"
                    templateColumns={{
                        base: "repeat(1, 1fr)",
                        md: "repeat(2, 1fr)",
                        lg: "repeat(3, 1fr)",
                    }}
                >
                    {loading &&
                        new Array(6).fill(0).map(() => {
                            return (
                                <GridItem mt="30px">
                                    <SkeletonTrack />
                                </GridItem>
                            );
                        })}
                    {order.length &&
                        order.map((el) => {
                            return (
                                <GridItem mt="30px">
                                    <ProductAddToCart img={el.images[0]} imgOnHover={el.images[1]} title={el.title} salePrice={el.price} regularPrice={Math.floor(+el.price * 0.9)} brand={el.brand} status={el.status} orderdate={el.date} id={el._id} type={el.type} discount={el.discount} toggleStatus={toggleStatus} deleteItem={deleteItem} />
                                </GridItem> 
                            );
                        })}
                </Grid>
            </Box>

            <Box>
                <Flex alignItems={"center"} w={"98%"} justifyContent={"center"} m={"auto"}>
                    {
                        <Button isDisabled={page !== 1 ? false : true} className="prevBtn" data-testid="prevBtn" onClick={() => changePage(page - 1)}>
                            Prev
                        </Button>
                    }

                    {/* render the buttons here, directly. Ensure, each button has the "data-testid='btn'" prop. Add the className, activeBtn, if the current button is the activePage*/}

                    <Button m="9px">{page}</Button>

                    {
                        <Button isDisabled={page != Math.ceil(length.current / 8) ? false : true} className="nextBtn" data-testid="nextBtn" onClick={() => changePage(page + 1)}>
                            Next
                        </Button>
                    }
                </Flex>
            </Box>
        </Box>
    );
};

export default TrackOrder;
